import Footer from "./Footer"
import ModalWithProvidedBody from "./ModalWithProvidedBody"

export default ModalWithProvidedBody
export { Footer }
